<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          color="primary"
          class="v-avatar-light-bg primary--text"
          v-on="on"
        >
          <v-img
            v-if="isError"
            max-height="128"
            max-width="128"
            contain
            :src="accountImage"
          >
          </v-img>
          <v-img
            v-else
            :src="avatar"
            @error="handleError"
          ></v-img>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            color="primary"
            class="v-avatar-light-bg primary--text"
          >
            <v-img
              v-if="isError"
              max-height="128"
              max-width="128"
              contain
              :src="accountImage"
            >
            </v-img>
            <v-img
              v-else
              :src="avatar"
              @error="handleError"
            ></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align: middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ userRecord.fullName || userRecord.firstName }}
          </span>
        </div>
      </div>

      <v-divider></v-divider>

      <v-list-item @click="logoutUser">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            mdi-logout
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>

// import {
//   mdiAccountOutline,
//   mdiEmailOutline,
//   mdiCheckboxMarkedOutline,
//   mdiChatOutline,
//   mdiCogOutline,
//   mdiCurrencyUsd,
//   mdiHelpCircleOutline,
//   mdiLogoutVariant,
// } from '@mdi/js'
import { ref, getCurrentInstance, computed } from 'vue'
import router from '@/router'
import { initialAbility } from '@/plugins/acl/config'
import { getUserData } from '@/utils/auth'

const vm = getCurrentInstance().proxy
const userData = getUserData()
const { userRecord } = userData
console.log('app bar', userData)

const isError = ref(false)
function handleError(e) {
  console.log('app bar handleerror', e)
  isError.value = true
}
const accountImage = computed(() => require('@/assets/images/AsianAlliance/account-circle.png'))

const avatar = computed(() => process.env.VUE_APP_BASE_API + userRecord.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')

const logoutUser = () => {
  // call react native to delete registrationToken
  try {
    const userDataForReactNative = window.localStorage.getItem('userData')
    window.ReactNativeWebView.postMessage('action:deleteFCM')
    window.ReactNativeWebView.postMessage(userDataForReactNative)
  } catch (err) {

  }

  // Remove userData from localStorage
  // ? We just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
  localStorage.removeItem('accessToken')

  // Remove userData & Ability from localStorage
  localStorage.removeItem('userData')
  localStorage.removeItem('userAbility')

  // Reset ability
  vm.$ability.update(initialAbility)

  // Redirect to login page
  router.push({ path: '/login' })
}

</script>

  <style lang="scss">
  .user-profile-menu-content {
    .v-list-item {
      min-height: 2.5rem !important;
    }
  }
  </style>
